import React from "react";
import { useTranslation } from "react-i18next";
import WifiOffIcon from "@mui/icons-material/WifiOff";
import ErrorCard from "./ErrorCard";
import RetryButton from "./RetryButton";

export default function ConnectionError(): React.ReactNode {
  const { t } = useTranslation();

  return (
    <ErrorCard
      icon={<WifiOffIcon sx={{ fontSize: 40 }} />}
      title={t("heading.no_connection")}
      description={t("text.no_connection_explanation")}
    >
      <RetryButton />
    </ErrorCard>
  );
}
